module.exports = __webpack_public_path__ + "img/nav-design-sets@2x.84ffe14.jpg";